export default __webpack_public_path__ + "static/media/icon_1.5852bf06.png";